﻿<script>
	import { tick } from "svelte";

	export let id;
	export let label = null;
	export let value;
	export let max = null;
	export let min = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let placeholder = null;

	const KEYBOARD = {
		BACKSPACE: 8,
		DELETE: 46
	};

	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(/\d/)) {
			return true;
		}

		e.preventDefault();
		return false;
	};
</script>

{#if label}<label for={id} class:isrequired={required}>{label}</label>{/if}
<input
	{required}
	{disabled}
	{readonly}
	{placeholder}
	{max}
	{min}
	type="number"
	bind:value
	{id}
	class="form-control"
	on:keydown={handleKeyDown}
	on:keypress={handleKeyPress}
/>
